import { connect } from "react-redux";
import { getAttendanceSummary } from "../../../../redux/overview/overviewState";
import HeaderComponent from "components/card/HeaderComponent";
import BarChartBase from "components/charts/BarChartBase";

const WeeklyAttendanceOverview = ( props ) => {
  const { } = props;
  const data = [
    { day: "Mon", Present: 180, Absent: 20 },
    { day: "Tue", Present: 160, Absent: 40 },
    { day: "Wed", Present: 200, Absent: 10 },
    { day: "Thu", Present: 150, Absent: 50 },
    { day: "Fri", Present: 170, Absent: 30 },
  ];

  return (
      <HeaderComponent
        title="Weekly Attendance Overview"
        description="Present vs Absent employees this week"
      >
          <BarChartBase
            data={data}
            xKey="day"
            height={330}
            yKeys={["Present", "Absent"]}
            barColors={["#8b5cf6", "#a78bfa"]}
          />
      </HeaderComponent>
 
  );
};
export default WeeklyAttendanceOverview;